import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PinsService } from 'src/app/services/pins.service';

@Component({
  selector: 'app-pins-column-molecule',
  templateUrl: './pins-column-molecule.component.html',
  styleUrls: ['./pins-column-molecule.component.scss']
})
export class PinsColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() cachedPinCounts!: { [key: string]: number };
  @Output() fetchPinCount: EventEmitter<void> = new EventEmitter<void>();
  

  constructor(private pinsService: PinsService,) { }
 

  refreshPinCount() {
    this.fetchPinCount.emit();
  }
}
